import React from "react";
import { CircleCheck, CircleX, Award, GraduationCap, BookOpen, ShieldCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TheMasterTeacherAdvantage() {
  const standardFeatures = ["Often taught by college students or generalists", "Focuses primarily on immediate homework completion", "Relies on rote memorization without deep understanding", "One-size-fits-all approach to problem solving"];
  const eqnFeatures = ["Taught by a former high school math teacher with 17 years of experience", "Focuses on conceptual understanding and procedural fluency", "High-impact, confidence-building approach", "Personalized lessons tailored to each student's needs"];
  return <section id="the-master-teacher-advantage" className="relative overflow-hidden bg-background py-24 lg:py-32">
      {}
      <div className="absolute -top-10 -left-10 z-0 select-none text-[15rem] font-bold leading-none text-muted/40 md:-top-20 md:-left-20 md:text-[25rem] lg:text-[30rem]" aria-hidden="true">
        01
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="mb-16 max-w-3xl">
          <span className="mb-4 block text-sm font-bold tracking-widest text-primary uppercase">
            The Master Teacher Advantage
          </span>
          <h2 className="font-default font-serif text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl">
            The Difference Experience Makes
          </h2>
          <p className="mt-6 text-lg text-muted-foreground">Not all tutoring is created equal. Discover why working with a credentialed, experienced educator transforms a student's mathematical journey from frustration to comprehension.</p>
        </div>

        <div className="grid gap-8 lg:grid-cols-2 lg:gap-12">
          {}
          <Card className="border-border/50 bg-muted/30 opacity-75 transition-opacity duration-300 hover:opacity-100">
            <CardHeader className="pb-4">
              <CardTitle className="font-default text-2xl text-muted-foreground">
                Standard Tutoring
              </CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-6">
                {standardFeatures.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                    <CircleX className="mt-1 h-6 w-6 shrink-0 text-muted-foreground/50" />
                    <span className="text-muted-foreground">{feature}</span>
                  </li>)}
              </ul>
            </CardContent>
          </Card>

          {}
          <Card className="border-primary/20 bg-primary text-primary-foreground shadow-2xl">
            <CardHeader className="pb-4">
              <CardTitle className="font-default text-3xl text-primary-foreground">Mr. Cottone's Method</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="mb-8 space-y-6">
                {eqnFeatures.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                    <CircleCheck className="mt-1 h-6 w-6 shrink-0 text-secondary" />
                    <span className="text-primary-foreground/90">{feature}</span>
                  </li>)}
              </ul>

              {}
              <div className="mt-8 rounded-lg bg-primary-foreground/10 p-6 backdrop-blur-sm">
                <h4 className="font-default mb-4 text-lg font-semibold text-secondary">
                  Elite Academic Credentials
                </h4>
                <div className="grid gap-4 sm:grid-cols-2">
                  <div className="flex items-center gap-3">
                    <GraduationCap className="h-5 w-5 text-secondary" />
                    <span className="text-sm text-primary-foreground/80">
                      BA in Math, UC Berkeley
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <BookOpen className="h-5 w-5 text-secondary" />
                    <span className="text-sm text-primary-foreground/80">
                      MA in Teaching Mathematics
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Award className="h-5 w-5 text-secondary" />
                    <span className="text-sm text-primary-foreground/80">National Board Certification</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <ShieldCheck className="h-5 w-5 text-secondary" />
                    <span className="text-sm text-primary-foreground/80">
                      CA & AZ Teaching Credentials
                    </span>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="h-14 px-8 text-lg">
            
          </Button>
        </div>
      </div>
    </section>;
}